var cropperOptions = {
  aspectRatio: 1 / 1,
  viewMode: 2,
  movable: false,
  zoomable: false,
  autoCrop: true,
  minCropBoxWidth: 150,
  minCropBoxHeight: 150,
  maxCropBoxWidth: 400,
  maxCropBoxHeight: 400,
  dragMode: 'move'
}

global.modules.set({
  async init(context) {
    $('.cropper', context).each(function () {
      var context = $(this);
      var preview = context.find('.preview');
      cropperOptions = $(this).data('free_space') ? { autoCrop: true } : cropperOptions;
      preview.on('click', function () {
        new Cropper($(this).get()[0], {
          ...cropperOptions,
          ready: function () {
            // this.cropper.setData(JSON.parse(JSON.parse(preview.attr('cropper_data'))))
          }
        });
      })
      var initialImage = preview.attr('src');
      $(this).closest('form').on('reset', function () {
        if (preview.get()[0].cropper) {
          preview.get()[0].cropper.destroy();
        }
        preview.attr('src', initialImage);
      })
      context.find('[type="file"]').on('change', function () {
        var preview = context.find('.preview');
        if (preview.get()[0].cropper) {
          preview.get()[0].cropper.replace(URL.createObjectURL($(this)[0].files[0]))
        } else {
          preview.attr('src', URL.createObjectURL($(this)[0].files[0]));
          new Cropper(preview.get()[0], cropperOptions);
        }
      })
    })
  }
})

  